var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v("©")]),_vm._v(" Saguaro Info d.o.o., "+_vm._s(_vm.year)+"., "),_c('strong',[_vm._v("IzzyEduPrijava: v2")])])])}
var staticRenderFns = []

export { render, staticRenderFns }